(() => {
  const menus = [...document.querySelectorAll('.pia-nav-item')];
  function setOpen(menu, open) {
    menu.classList.toggle('is-open', open);
    menu.querySelector('.pia-primary-link').setAttribute('aria-expanded', String(open));
  }
  menus.forEach(menu => {
    const open = () => { menus.forEach(other => setOpen(other, other === menu)); };
    menu.addEventListener('pointerenter', open);
    menu.addEventListener('focusin', open);
    menu.addEventListener('pointerleave', () => { if (!menu.contains(document.activeElement)) setOpen(menu, false); });
    menu.addEventListener('focusout', event => { if (!menu.contains(event.relatedTarget)) setOpen(menu, false); });
    menu.addEventListener('keydown', event => {
      if (event.key === 'Escape') { event.preventDefault(); menu.querySelector('.pia-primary-link').focus(); setOpen(menu, false); }
      if (event.key === 'ArrowDown' && event.target.classList.contains('pia-primary-link')) { event.preventDefault(); open(); menu.querySelector('.pia-dropdown a')?.focus(); }
    });
  });
  document.addEventListener('click', event => { if (!event.target.closest('.pia-primary')) menus.forEach(menu => setOpen(menu, false)); });
  function updateNavigation() {
    const here = new URL(location.href);
    const view = here.searchParams.get('view') || '';
    const placeView = /^passage-(places|madrid|los-angeles|san-francisco)$/.test(view);
    document.querySelectorAll('.pia-dropdown a,.passage-foot nav a,.pia-tools a').forEach(link => {
      const target = new URL(link.href, location.origin);
      let active = target.pathname === here.pathname && !target.hash;
      for (const key of ['view', 'use', 'place']) {
        let current = here.searchParams.get(key) || '';
        let expected = target.searchParams.get(key) || '';
        if (key === 'view' && /\/collections\//.test(here.pathname)) { if (current === 'passage-shop') current = ''; if (expected === 'passage-shop') expected = ''; }
        if (key === 'view' && /\/blogs\//.test(here.pathname)) { if (current === 'passage-journal') current = ''; if (expected === 'passage-journal') expected = ''; }
        active = active && current === expected;
      }
      if (active) link.setAttribute('aria-current', 'page'); else link.removeAttribute('aria-current');
    });
    document.querySelectorAll('.pia-primary-link').forEach(link => {
      const label = link.textContent.trim();
      const active = label === 'JOURNAL' ? here.pathname.startsWith('/blogs/') : label === 'PLACES' ? placeView : label === 'SHOP' && !placeView && (/^\/(collections|products)\//.test(here.pathname));
      if (active) link.setAttribute('aria-current', 'page'); else link.removeAttribute('aria-current');
    });
  }
  updateNavigation();
  document.querySelectorAll('[data-pia-catalog]').forEach(catalog => {
    const map = window.PassageArchitectureMap || {};
    const products = [...catalog.querySelectorAll('[data-pia-product]')];
    const useControl = catalog.querySelector('[name="pia-use"]');
    const editControl = catalog.querySelector('[name="pia-edit"]');
    const placeControl = catalog.querySelector('[name="pia-place"]');
    const sortControl = catalog.querySelector('[name="pia-sort"]');
    const count = catalog.querySelector('[data-pia-count]');
    const empty = catalog.querySelector('[data-pia-empty]');
    const validUses = ['all', 'wear', 'carry', 'write', 'home', 'give'];
    const validPlaces = ['all', 'madrid', 'los-angeles', 'san-francisco'];
    function apply(updateUrl = false) {
      const params = new URLSearchParams(location.search);
      const selectedUse = useControl.value;
      const selectedPlace = placeControl.value;
      const fixed = catalog.dataset.fixed;
      let matches = 0;
      products.forEach(product => {
        const data = map[product.dataset.piaProduct] || {uses: [], place: '', edits: []};
        const show = (selectedUse === 'all' || data.uses.includes(selectedUse)) && (selectedPlace === 'all' || data.place === selectedPlace) && (!fixed || data.edits.includes(fixed));
        product.hidden = !show;
        if (show) matches++;
      });
      count.textContent = count.dataset.template.replace('__COUNT__', String(matches));
      empty.hidden = matches !== 0;
      [useControl, placeControl, editControl].forEach(control => control.classList.toggle('is-selected', control.value !== 'all'));
      if (updateUrl) {
        selectedUse === 'all' ? params.delete('use') : params.set('use', selectedUse);
        selectedPlace === 'all' ? params.delete('place') : params.set('place', selectedPlace);
        params.delete('page');
        history.replaceState(null, '', location.pathname + (params.size ? '?' + params.toString() : '') + location.hash);
        updateNavigation();
      }
    }
    function restore() {
      const params = new URLSearchParams(location.search);
      useControl.value = validUses.includes(params.get('use')) ? params.get('use') : 'all';
      placeControl.value = validPlaces.includes(params.get('place')) ? params.get('place') : 'all';
      apply();
    }
    useControl.addEventListener('change', () => apply(true));
    placeControl.addEventListener('change', () => apply(true));
    editControl.addEventListener('change', () => {
      const url = new URL(location.href);
      editControl.value === 'all' ? url.searchParams.delete('view') : url.searchParams.set('view', 'passage-' + editControl.value);
      url.searchParams.delete('page'); location.href = url.href;
    });
    sortControl.addEventListener('change', () => {
      const url = new URL(location.href); url.searchParams.set('sort_by', sortControl.value); url.searchParams.delete('page'); location.href = url.href;
    });
    window.addEventListener('popstate', () => {restore(); updateNavigation();});
    restore();
  });
})();
